import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
} from '../../../models/https';
import { locumJobsActions } from '../../../redux/slices/locumJobsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

interface JobsFilter {
  page?: string;
  perPage?: string;
  keyword?: string;
  location?: string;
  payInterval?: string;
}

const useGetLocumJobs = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetLocumJobsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching locum jobs'
    );
  };

  const getLocumJobs = (filter?: JobsFilter) => {
    // Extract pagination values from the filter or use defaults
    const page = parseInt(filter?.page ?? '1', 9);
    const perPage = parseInt(filter?.perPage ?? '10', 10);

    // Build the base URL
    let urlPath = `jobs-service/jobs/?isFilled=false&limit=${perPage}&offset=${page}`;

    // Append search query parameters if provided
    if (filter?.keyword) {
      urlPath += `&keyword=${encodeURIComponent(filter.keyword)}`;
    }
    if (filter?.location) {
      urlPath += `&location=${encodeURIComponent(filter.location)}`;
    }
    if (filter?.payInterval) {
      urlPath += `&payInterval=${encodeURIComponent(filter.payInterval)}`;
    }

    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onGetLocumJobsSuccess = (response: PaginatedResponse) => {
      console.log('data received:', response);
      const {
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        content,
      } = response;

      // // Filter out jobs where isFilled is true
      // const filteredContent = content.filter(
      //   (job: { isFilled: boolean }) => !job.isFilled
      // );

      dispatch(
        locumJobsActions.updateLocumJobs({
          page, // pass the original page number for UI purposes
          perPage,
          totalPages,
          totalElements,
          numberOfElements,
          first,
          last,
          content: content,
        })
      );
    };

    return request(url, onGetLocumJobsSuccess, setLoading, onGetLocumJobsError);
  };

  return { getLocumJobs, loading };
};

export default useGetLocumJobs;
